<template>
  <div class="w-full bg-white height-100">
    <el-dialog
      width="30%"
      title=""
      :visible.sync="isshowCampaignPopup"
      :direction="direction"
      :before-close="handleClose"
    >
      <div slot="title" class="bg-primary">
        <h3 class="fsize14 mb-0 Add Products text-white">Add Campaign</h3>
      </div>
      <div>
        <div class="px-2">
          <div>
            <div class="flex justify-center gap-3">
              <div class="w-1/4 text-center">
                <img
                  @click="handleClick2('whatsapp-Campaign')"
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/whatsapp01.png"
                  alt="new"
                  class="w-16 h-16 cursor-pointer"
                />
              </div>
              <div class="w-1/4 text-center">
                <img
                  @click="handleClick2('SMS-Campaign')"
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/sms.png"
                  alt="new"
                  class="w-16 h-16 cursor-pointer"
                />
              </div>
              <div class="w-1/4 text-center">
                <img
                  @click="handleClick2('pushNotification-Campaign')"
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/push.png"
                  alt="new"
                  class="w-16 h-16 cursor-pointer"
                />
              </div>
              <div class="w-1/4 text-center">
                <img
                  @click="handleClick2('email-Campaign')"
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/email.png"
                  alt="new"
                  class="w-16 h-16 cursor-pointer"
                />
              </div>
            </div>
            <!-- <el-select
              v-model="selectedCampaign"
              class="mt-2"
              placeholder="Enter.."
            >
              <el-option
                v-for="item in Campaignoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                class="mt-2 w-full"
              >
              </el-option>
            </el-select> -->
          </div>

          <!-- <div class="grid grid-cols-2 gap-4 justify-center mt-8 items-center">
            <vs-button
              @click="handleClick"
              class="w-full border-0 text-white rounded-lg font-normal lg:py-3 fsize14 md:py-3 py-2 px-4 sm-fsize14"
            >
              Confirm Campaign
            </vs-button>

            <vs-button
              @click="isshowCampaignPopup = false"
              type="secondary"
              class="rounded-lg bg-secondary border-0 text-white font-medium fsize14 py-3 w-full sm-fsize14"
            >
              Cancel
            </vs-button>
          </div> -->
        </div>
      </div>
    </el-dialog>

    <el-dialog
      width="30%"
      title=""
      :visible.sync="isshowCampaignpreview"
      :direction="direction"
      :before-close="handleClose"
    >
      <div slot="title" class="bg-primary">
        <h2 class="font-semibold fsize14 text-dark mb-1">Template Preview</h2>
      </div>
      <div>
        <div class="px-2">
          <div>
            <p class="fsize12 col-4f4f4f opacity-80">
              Edit, Organize and Delete your segments
            </p>
          </div>

          <div class="bg-f4f5f6 p-6 rounded-6px mt-8">
            <img
              alt="image"
              class="temp-previewh"
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Ecom/ecom.svg"
            />
          </div>
          <div class="mt-12">
            <h2 class="font-semibold fsize16 text-dark mb-1">Reason:</h2>
            <p class="fsize12 col-4f4f4f opacity-80">
              Invalid detail Campaign provided
            </p>
          </div>
          <div class="justify-center mt-12 items-center">
            <vs-button
              class="bg-primary w-full px-8 py-4 rounded-full border-0 font-medium fsize14"
            >
              Rejected
            </vs-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            My Campaigns
          </h2>
        </div>
      </div>
    </div>
    <div class="px-6 py-8 menucontrol-scroll fixed-top bg-white">
      <div class="w-full">
        <div class="w-full flex items-center justify-between">
          <div class="w-4/12">
            <div>
              <small class="fsize12 bg-white text-dark font-medium"
                >Search Keywords</small
              >
              <div class="relative">
                <el-input
                  placeholder="Search"
                  class="w-full mt-2"
                  v-model="input"
                  @onchange="input"
                ></el-input>
                <div class="absolute topright-adj bg-white cursor-pointer">
                  <feather-icon icon="SearchIcon" svgClasses="w-6 h-6" />
                </div>
              </div>
            </div>
          </div>
          <div class="w-8/12 flex items-end gap-2 pl-2">
            <div class="w-10/12 flex gap-3">
              <div class="">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Search by Campaign</small
                >
                <el-select
                  v-model="value0"
                  placeholder=""
                  class="w-full border-2 mt-2 rounded-lg"
                >
                  <el-option
                    v-for="item in Campaignoptions"
                    :key="item.label"
                    :label="item.label"
                    :value="item.label"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Search From
                </small>
                <el-date-picker
                  v-model="date1"
                  type="date"
                  placeholder="Pick a day"
                  class="mt-2 w-full"
                >
                </el-date-picker>
              </div>
              <div class="">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Search to</small
                >
                <el-date-picker
                  v-model="date2"
                  type="date"
                  placeholder="Pick a day"
                  class="mt-2 w-full"
                >
                </el-date-picker>
              </div>
            </div>
            <div class="w-2/12 flex justify-end">
              <vs-button
                @click="isshowCampaignPopup = true"
                class="bg-primary px-5 py-3 border-none rounded-lg text-white flex items-center"
              >
                Create New
              </vs-button>
            </div>
          </div>
        </div>
        <!-- <div class="w-full flex gap-4 justify-between">
          <div class="w-2/5">
            <div>
              <small class="fsize12 bg-white text-dark font-medium"
                >Search Keywords</small
              >
              <div class="relative">
                <el-input
                  placeholder="Search"
                  class="w-full mt-2"
                  v-model="input"
                ></el-input>
                <div class="absolute topright-adj bg-white cursor-pointer">
                  <feather-icon icon="SearchIcon" svgClasses="w-6 h-6" />
                </div>
              </div>
            </div>
          </div>
          <div class="w-3/5 flex items-end gap-2 pl-6">
            <div class="w-2/5">
              <small class="fsize12 bg-white text-dark font-medium"
                >Search by Campaign</small
              >
              <el-select
                v-model="value0"
                placeholder="pending"
                class="w-full border-2 mt-2 rounded-lg"
              >
                <el-option
                  v-for="item in Campaignoptions"
                  :key="item.label"
                  :label="item.label"
                  :value="item.label"
                >
                </el-option>
              </el-select>
            </div>
            <div class="">
              <small class="fsize12 bg-white text-dark font-medium"
                >Search From
              </small>
              <el-date-picker
                v-model="date1"
                type="date"
                placeholder="Pick a day"
                class="mt-2 w-full"
              >
              </el-date-picker>
            </div>
            <div class="">
              <small class="fsize12 bg-white text-dark font-medium"
                >Search to</small
              >
              <el-date-picker
                v-model="date2"
                type="date"
                placeholder="Pick a day"
                class="mt-2 w-full"
              >
              </el-date-picker>
            </div>
            <div class="flex justify-end ml-1">
              <vs-button
                @click="isshowCampaignPopup = true"
                class="bg-primary px-4 py-3 border-none rounded-lg text-white flex items-center"
              >
                Add New
              </vs-button>
            </div>
          </div>
        </div> -->
        <div class="w-full grid grid-cols-3 gap-8 mt-8">
          <div
            class="flex items-center bg-white cursor-pointer cust-shadow border-round p-4"
            v-for="(item, index) in Cards.result"
            :key="('item-', +index)"
            @click="CampaignDetails(item)"
          >
            <div class="flex gap-4 w-10/12">
              <img
                v-if="item.type == 'whatsApp'"
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/whatsapp01.png"
                class="object-contain w-16 h-16"
              />
              <img
                v-if="item.type == 'email'"
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/email.png"
                class="object-contain w-16 h-16"
              />
              <img
                v-if="item.type == 'sms'"
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/sms.png"
                class="object-contain w-16 h-16"
              />
              <img
                v-if="item.type == 'pushNotification'"
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/push.png"
                class="object-contain w-16 h-16"
              />

              <div class="w-full">
                <!-- <small class="col-4f fsize10">{{ item.top }}</small> -->
                <h3 class="col-4f fsize16 mb-0 flex gap-1 items-center">
                  {{ item.title ? item.title : item.name }}
                </h3>
                <div class="flex justify-between w-full mt-2">
                  <div>
                    <p class="fsize10 font-semibold mb-0 col-4f">Date</p>
                    <p class="fsize10 mb-0 text-8f8f8f">
                      {{ item.createdAt.split("T")[0] }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-2/12 flex justify-end cursor-pointer">
              <div>
                <img
                  src="@/assets/images/aright.png"
                  class="w-12 h-12 rounded-full"
                />
              </div>
            </div>
          </div>
        </div>
        <div v-if="totalLength === 0">
          <div class="text-center">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brainedadmin/images/nodatafound.svg"
              alt="image"
              class="w-1/3"
            />
          </div>
        </div>
        <div class="w-full flex justify-end mt-6">
          <el-pagination
            @current-change="
              (value) => {
                currentPage = value;
                getAll();
              }
            "
            :page-size="12"
            :total="totalLength"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import VueEllipseProgress from "vue-ellipse-progress";
const debounce = function debounce(func, wait = 800) {
  let debounceTimer;
  return function (...args) {
    if (debounceTimer) clearTimeout(debounceTimer);
    const context = this;
    debounceTimer = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
};
export default {
  data() {
    return {
      input: "",
      selectedCampaign: "",
      isshowCampaignPopup: false,
      isshowCampaignpreview: false,
      value0: "All",
      currentPage: 1,
      Campaignoptions: [
        {
          value: "All",
          label: "All",
        },
        {
          value: "SMS-Campaign",
          label: "SMS",
        },
        {
          value: "email-Campaign",
          label: "Email",
        },
        {
          value: "pushNotification-Campaign",
          label: "Push Notification",
        },
        {
          value: "whatsapp-Campaign",
          label: "Whats App",
        },
      ],
      Cards: [],
      date1: "",
      date2: "",
    };
  },
  watch: {
    value0: {
      handler: function (val) {
        // if (val) {
        this.currentPage = 1;
        this.getAll();
        // this.$store.commit("campaign/SELECTED_CAMPAIGN", payload);
        // }
      },
      deep: true,
    },
    input: debounce(async function () {
      this.getAll();
    }),

    date1: debounce(async function (newValue) {
      if (newValue !== "" && this.date2) {
        this.getAll();
      }
    }),
    date2: debounce(async function (newValue) {
      if (this.date1 && newValue !== "") {
        this.getAll();
      }
    }),
  },
  mounted() {
    this.getAll();
  },
  methods: {
    async getAll() {
      try {
        if (this.currentPage == 1) {
          let payload = {
            campaign: this.value0,
          };
          if (this.value0 === "SMS") {
            if (this.input) {
              Object.assign(payload, { title: this.input });
            }
            if (this.date1 && this.date2) {
              if (this.date1) {
                Object.assign(payload, { createdAt: true });
                Object.assign(payload, { date1: this.date1 });
              }
              if (this.date2) {
                Object.assign(payload, { createdAt: true });
                Object.assign(payload, { date2: this.date2 });
              }
            }
            let data = await this.$store.dispatch("campaign/getAll", payload);
            // console.log(data);
            this.Cards = data.data;
            this.totalLength = data.data.totalLength;
          } else {
            if (this.input) {
              Object.assign(payload, { name: this.input });
            }

            if (this.date1 && this.date2) {
              if (this.date1) {
                Object.assign(payload, { createdAt: true });
                Object.assign(payload, { date1: this.date1 });
              }
              if (this.date2) {
                Object.assign(payload, { createdAt: true });
                Object.assign(payload, { date2: this.date2 });
              }
            }
            let data = await this.$store.dispatch("campaign/getAll", payload);
            // console.log(data);
            this.Cards = data.data;
            this.totalLength = data.data.totalLength;
          }
        }
        // if (
        //   inputValue ||
        //   (this.date1 && this.date2) ||
        //   (inputValue && this.date1 && this.date2)
        // ) {
        //   if (this.value0 === "SMS") {
        //     let payload = {
        //       campaign: this.value0,
        //       offset: (this.currentPage - 1) * 10,
        //     };

        //     let data = await this.$store.dispatch("template/getAll", payload);
        //     // console.log(data);
        //     this.Cards = data.data;
        //     this.totalLength = data.data.totalLength;
        //   } else {
        //     let payload = {
        //       campaign: this.value0,
        //       offset: (this.currentPage - 1) * 10,
        //       templateName: inputValue,
        //     };
        //     let data = await this.$store.dispatch("template/getAll", payload);
        //     // console.log(data);
        //     this.Cards = data.data;
        //     this.totalLength = data.data.totalLength;
        //   }
        // }
        else {
          let payload = {
            campaign: this.value0,
            offset: (this.currentPage - 1) * 12,
          };
          if (this.value0 === "SMS") {
            if (this.input) {
              Object.assign(payload, { title: this.input });
            }
            if (this.date1 && this.date2) {
              if (this.date1) {
                Object.assign(payload, { createdAt: true });
                Object.assign(payload, { date1: this.date1 });
              }
              if (this.date2) {
                Object.assign(payload, { createdAt: true });
                Object.assign(payload, { date2: this.date2 });
              }
            }
            let data = await this.$store.dispatch("campaign/getAll", payload);
            // console.log(data);
            this.Cards = data.data;
            this.totalLength = data.data.totalLength;
          } else {
            if (this.input) {
              Object.assign(payload, { name: this.input });
            }

            if (this.date1 && this.date2) {
              if (this.date1) {
                Object.assign(payload, { createdAt: true });
                Object.assign(payload, { date1: this.date1 });
              }
              if (this.date2) {
                Object.assign(payload, { createdAt: true });
                Object.assign(payload, { date2: this.date2 });
              }
            }
            let data = await this.$store.dispatch("campaign/getAll", payload);
            // console.log(data);
            this.Cards = data.data;
            this.totalLength = data.data.totalLength;
          }
          // const query = this.input.toLowerCase();
          // return this.Cards.sms.filter((x) =>
          //   x.name.toLowerCase().includes(query)
          // );
        }
      } catch (err) {
        console.log(err);
      }
    },
    handleClick() {
      this.$router.push({ name: this.selectedCampaign });
    },
    handleClick2(name) {
      this.$router.push({ name: name });
    },

    CampaignDetails(item) {
      // alert("hello");
      let payload = {
        campaign: item,
        campaignName: this.value0,
      };
      Object.assign(payload, { campaignName: this.value0 });

      this.$store.commit("campaign/CAMPAIGN", payload);
      this.$router.push({ name: "marcom-campaignDetails" });
      // console.log(payload);
    },
  },
};
</script>
